
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {promptMessage,fetch,baseUrl} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import $ from 'jquery';
import SLsfzZimg from './images/sl-sfzZ.jpg';
import SLsfzFimg from './images/sl-sfzF.jpg';
import SLmarryimg from './images/sl-marryImg.jpg';
import SLgroupphotoimg from './images/sl-groupphoto.jpg';
export default {
data()
{
return {
SLmarryimg,
SLsfzFimg,
SLsfzZimg,
SLgroupphotoimg,
cardValue:'',
nameValue:'',
dateValue:'',
maxYear:'',
confirmshow:false,
disabled:false,
marryImgSrc:'',
SFZImgSrcZ:'',
SFZImgSrcF:'',
groupphotoImgSrc:'',
showdialog:false,
toastTxt:'',
toastShow:false,
dialogSrc:'',
groupphotoImg:false,
marryImg:false,
SFZImgZ:false,
SFZImgF:false,
tellValue:'',
SFZValue:'',
contact:{
SFZZTxt:'',
SFZFTxt:'',
groupphotoTxt:'',
marryTxt:''
}

}
},
directives: {
TransferDom
},
methods:{
Imgsuccess (src, ele) {
const span = ele.parentNode.querySelector('span')
ele.parentNode.removeChild(span)
},
Imgerror (src, ele, msg) {
const span = ele.parentNode.querySelector('span');
if(src == ''){
span.innerText = '该图片不存在';
}else {
span.innerText = '图片加载失败，请刷新页面！'
}
ele.parentNode.removeChild(ele);


},
submit(){
if(this.marryImgSrc !=''&& this.SFZImgSrcZ !='' && this.SFZImgSrcF !='' && this.groupphotoImgSrc !=''){

this.$store.commit('updateLoadingStatus',{isLoading:true});
for(let i=0;i<this.recordCategoryList.length;i++){
delete this.recordCategoryList[i].paperClassify;
delete this.recordCategoryList[i].ivfPatientId;
delete this.recordCategoryList[i].reviewState;
}
this.paramsData = {};
this.paramsData.ivfPatientId = this.ivfPatientId;
this.paramsData.recordCategoryList = this.recordCategoryList;
fetch('post',urlConfig.filingInformationImgSave,this.paramsData).then(response =>{
this.$store.commit('updateLoadingStatus',{isLoading:false})
promptMessage('提示','提交成功！',this.alertHide());
}).catch(error =>{

});
}else {
promptMessage('提示','还有图片未上传！');
}
},  //下一步
alertHide(){
return function(){
window.location.reload();
}
},
noconfim(title,con){
promptMessage(title,con);
}, //没有证件弹框
deleImgClick(code){
this.confirmshow = true;
this.confirmCode = code;

}, //删除
onConfirm(){
this.$store.commit('updateLoadingStatus',{isLoading:true})
let code = this.confirmCode;
for(let i=0;i<this.recordCategoryList.length;i++){
if(this.recordCategoryList[i].categoryType == code){
this.imgparms ={};
this.imgparms.ivfPatientId = this.ivfPatientId;
this.imgparms.path = 'ivf';
this.imgparms.picName = this.recordCategoryList[i].picName;
this.imgparms.id = this.recordCategoryList[i].id
fetch('post',urlConfig.filingInformationImgDelete,this.imgparms).then(response =>{
if(code == 2){
this.marryImgSrc = '';
this.marryImg = false;
this.contact.marryTxt ='';
}else if(code == 0){
this.SFZImgZ = false;
this.contact.SFZZTxt ='';
this.SFZImgSrcZ = '';
}else if(code == 1){
this.contact.SFZFTxt ='';
this.SFZImgF = false;
this.SFZImgSrcF = '';
}else if(code == 3){
this.groupphotoImg = false;
this.groupphotoImgSrc = '';
this.contact.groupphotoTxt ='';
}
this.recordCategoryList.splice(i,1);
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.toastTxt = '图片已删除';
this.toastShow = true;
}).catch(error =>{
promptMessage('提示','图片删除失败，请重新删除！')
});
}
}
},
uploadChange(e,src){
var _this = this;
this.$store.commit('updateLoadingStatus',{isLoading:true});
let files = e.target.files;
var reader = new FileReader();
for(let i =0;i<files.length;i++){
if((files.size/1024)/1024 > 10){ // 如果大于10M
promptMessage('提示','上传图片过大，无法上传！');
return false;
}
let event = e;
reader.readAsDataURL(files[i]);
reader.onload=function(e){
var fromUpdate = new FormData();
fromUpdate.append('uploadfile',files[i]);
fromUpdate.append('filepath','ivf/'+ _this.ivfPatientId);
fromUpdate.append('rename','true');
fetch('post',urlConfig.imgUpdate,fromUpdate).then(response => {
console.log(response,7)
if(src == 2){
_this.marryImg = true;
_this.marryImgSrc = e.target.result;
_this.contact.marryTxt ='审核中···';
}else if(src == 0){
_this.SFZImgZ = true;
_this.SFZImgSrcZ = e.target.result;
_this.contact.SFZZTxt ='审核中···';
}else if(src == 1){
_this.SFZImgF = true;
_this.SFZImgSrcF = e.target.result;
_this.contact.SFZFTxt ='审核中···';
}else if(src == 3){
_this.groupphotoImg = true;
_this.groupphotoImgSrc = e.target.result;
_this.contact.groupphotoTxt ='审核中···';
}
_this.recordCategoryList.push({id:'',categoryType:src,picName:response.filename.substr(response.filename.lastIndexOf('/') +1)})
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
});
event.target.value = null;
}

}

},  //上传图片
diagClick(src){
this.showdialog = true;
this.dialogSrc = src;

}, // 点击图片放大
getUserId(){
fetch('get',urlConfig.GetSfzh +'?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);
this.sfzh = response.sfzh;
this.EmbryoList(response.sfzh);

}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.getData(response.personInfoId);
}).catch(error => {

})

},
getData(personInfoId){
fetch('get',urlConfig.getfilingInformation + '?personInfoId='+personInfoId).then(response => {
console.log(response,6)
this.reviewState = [];
this.cardValue = response.patientInfoDto.identityNo;
this.nameValue = response.patientInfoDto.patientName;
this.dateValue = response.patientInfoDto.birthday;
this.tellValue = response.patientInfoDto.phoneNumber;
this.SFZValue = response.patientInfoDto.idCard;
this.ivfPatientId = response.ivfPatientId;
if(response.recordCategoryList == null){
this.recordCategoryList = [];
this.$store.commit('updateLoadingStatus',{isLoading:false})
}else {
this.recordCategoryList = response.recordCategoryList;
for(let i = 0; i<response.recordCategoryList.length;i++){
this.recordCategoryList[i].categoryType = this.recordCategoryList[i].paperClassify.code;
if(response.recordCategoryList[i].reviewState == 1){
this.reviewState.push(i);
if(response.recordCategoryList[i].paperClassify.code == 0){
this.contact.SFZZTxt ='已通过审核';
this.SFZImgSrcZ = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.SFZImgZ = true;
this.$nextTick(function () {
$('.SFZZ').hide();
})

}else if(response.recordCategoryList[i].paperClassify.code == 1){
this.contact.SFZFTxt ='已通过审核';
this.SFZImgSrcF = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.SFZImgF = true;
this.$nextTick(function () {
$('.SFZF').hide();
})
}else if(response.recordCategoryList[i].paperClassify.code == 2){
this.contact.marryTxt ='已通过审核';
this.marryImgSrc = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.marryImg = true;
this.$nextTick(function () {
$('.marry').hide();
})
}else if(response.recordCategoryList[i].paperClassify.code == 3){
this.contact.groupphotoTxt ='已通过审核';
this.groupphotoImgSrc = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.groupphotoImg = true;
this.$nextTick(function () {
$('.groupphoto').hide();
})
}

}else {
if(response.recordCategoryList[i].paperClassify.code == 0){
this.contact.SFZZTxt ='审核中···';
this.SFZImgSrcZ = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.SFZImgZ = true;

}else if(response.recordCategoryList[i].paperClassify.code == 1){
this.contact.SFZFTxt ='审核中···';
this.SFZImgSrcF = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.SFZImgF = true;
}else if(response.recordCategoryList[i].paperClassify.code == 2){
this.contact.marryTxt ='审核中···';
this.marryImgSrc = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.marryImg = true;
}else if(response.recordCategoryList[i].paperClassify.code == 3){
this.contact.groupphotoTxt ='审核中···';
this.groupphotoImgSrc = baseUrl+urlConfig.imgLook + '/ivf/' + this.ivfPatientId+'/'+response.recordCategoryList[i].picName + '?token=' + window.localStorage.getItem('token');
this.groupphotoImg = true;
}
}
}
}
if(this.reviewState.length == 4){
promptMessage('提示','您提交的申请已通过审核！');
this.disabled = false;
}else {
this.disabled = true;
}
this.$store.commit('updateLoadingStatus',{isLoading:false})

}).catch(error => {

})
}
},
components: {
XImg,Confirm, Toast,Cell,InlineLoading , XDialog, PopupRadio,Grid, GridItem, Datetime, XInput, Group,XButton
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true})
getken(this.getUserId);
document.title = '建档预约申请';
this.openid = this.$route.query.openid;
this.maxYear = dateFormat(new Date(), 'YYYY-MM-DD');

}
}



// WEBPACK FOOTER //
// ./src/project/selfHelpFilingProject/filingInformation.vue